import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  Box,
  Button,
  Card,
  Checkbox,
  Typography
} from '@mui/material';

import { Swiper, SwiperSlide } from 'swiper/react';

import CircularProgress from '@mui/material/CircularProgress';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useFieldApi } from '@data-driven-forms/react-form-renderer';
import { useUpload } from '../../hooks/useUpload';
import { AsyncImage } from '../../components/AsyncImage/AsyncImage';

const allowedTypes = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'video/mp4',
  'video/quicktime',
  'audio/mpeg',
  'audio/wav'
  // Add more supported types as needed
];

export const PrizetS3UploadFieldProvider = (props) => {
  const { input } = useFieldApi(props);
  const { setFiles, bucketLinks, setBucketLinks } =
    useUpload();

  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    const filesArray: File[] = Array.from(selectedFiles);
    const filteredFiles = filesArray.filter((file: File) =>
      allowedTypes.includes(file.type)
    );

    setFiles(filteredFiles);
    setLoading(true);
  };

  useEffect(() => {
    if (bucketLinks?.length === 0) return;
    setLoading(false);
    input.onChange(bucketLinks);
  }, [bucketLinks]);

  useEffect(() => {
    setBucketLinks(props.initialValue);
  },[]);

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  });

  return (
    <Box
      display={'flex'}
      sx={{
        width: '100%'
      }}
      flexDirection={'column'}
      columnGap={2}
    >
      <Box display={'flex'} flexDirection={'row'}>
        <Button
          style={{ color: 'white' }}
          component="label"
          role={'button'}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUploadIcon />}
        >
          Upload files
          <VisuallyHiddenInput
            type="file"
            onChange={handleFileChange}
            multiple
          />
        </Button>
      </Box>

      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ marginTop: 2 }}
        >
          <CircularProgress />
          <Typography sx={{ marginLeft: 2 }}>Uploading...</Typography>
        </Box>
      )}

      {bucketLinks?.length > 0 && !loading && (
        <Box sx={{ width: 345, padding: '2%' }}>
          <Card sx={{ maxWidth: 'auto' }}>
            <Swiper
              navigation
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={50}
              slidesPerView={1}
            >
              {bucketLinks.map((item, index) => (
                <SwiperSlide key={index}>
                  <div style={{ marginLeft: '15%' }} key={item.image}>
                    <AsyncImage
                      h={250}
                      w={250}
                      url={item.image}
                      key={item.image}
                    />
                    <Box
                      sx={{
                        padding: '2%',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}
                      display={'flex'}
                    >
                      {index + 1}/{bucketLinks?.length}
                    </Box>
                    <Checkbox
                      checked={item.isThumbnail}
                      onChange={(e) => {
                        item = { ...item, isThumbnail: !item.isThumbnail };
                        const temporaryItem = bucketLinks[index];

                        bucketLinks[index] = item;

                        setBucketLinks([
                          ...bucketLinks.map((record) => ({
                            ...record,
                            isThumbnail:
                              record.image === item.image
                                ? item.isThumbnail
                                : false
                          }))
                        ]);
                        e.currentTarget.checked = item.isThumbnail;
                      }}
                    />{' '}
                    <span> Set as thumbnail </span>
                    <Button
                      onClick={() => {
                        bucketLinks.splice(index, 1);
                        setBucketLinks([...bucketLinks]);
                      }}
                    >
                      Remove
                    </Button>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Card>
        </Box>
      )}
    </Box>
  );
};
